"use client";

import { cn } from "@/lib/utils";
import { IconMessageOff } from "@tabler/icons-react";
import type { ComponentProps } from "react";

export type ConversationsMenuEmptyStateProps = ComponentProps<"div">;

export function ConversationsMenuEmptyState({
  className,
  ...props
}: ConversationsMenuEmptyStateProps) {
  return (
    <div
      className={cn(
        "my-auto flex w-full flex-col items-center justify-center gap-3 p-8 text-center",
        className,
      )}
      {...props}
    >
      <div className="text-muted-foreground bg-muted rounded-full p-4">
        <IconMessageOff className="size-8" />
      </div>
      <div className="space-y-1">
        <h3 className="text-sm font-medium">No conversations yet</h3>
        <p className="text-muted-foreground text-xs">
          Start a conversation with a character to see it here
        </p>
      </div>
    </div>
  );
}
